export default {
	field: 'Väli',
	oldValue: 'Vana',
	newValue: 'Uus',
	intable: 'tabelis',
	verbs: {
		INSERT: 'lõi uue',
		UPDATE: 'uuendas',
		DELETE: 'kustutas',
	},
	tables: {
		risks: 'Alusriskid',
		risk_meta: 'Riskid',
		documents: 'Dokumendid',
		urls: 'URLid',
	},
	fields: {
		risks: {
			code: 'Kood',
			name: 'Nimi',
			description: 'Kirjeldus',
			catalog_id: 'Kataloog',
			is_custom: 'Kohandatud',
		},
		risk_meta: {
			responsible: 'Vastutaja',
			instance_id: 'Asutus',
			confidentiality: 'Konfidentsiaalsus',
			integrity: 'Terviklus',
			availability: 'Käideldavus',
			accepted_residual_risk: 'Aktsepteeritav jääkrisk',
			comment: 'Kommentaar',
			probability: 'Tõenäosus',
			impact: 'Mõju',
			score: 'Riskiskoor',
			residual: 'Jääkrisk',
			treatment: 'Käsitlus',
			due_date: 'Tähtaeg',
			catalog_meta_id: 'Kataloog',
			category_meta_id: 'Kategooria',
			last_review: 'Viimane ülevaatus',
		},
		documents: {
			name: 'Nimi',
			path: 'Asukoht',
			length: 'Suurus',
			content: 'Sisu',
			instance_id: 'Asutus',
			author_id: 'Looja',
		},
		urls: {
			path: 'Asukoht',
			instance_id: 'Asutus',
			author_id: 'Looja',
			url: 'URL',
		},
	},
}
